// Styles for WysiwygText go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledWysiwygText = styled.div`
.txt-container {
    padding: ${toRem(32)} 0;
  }
  .txt-container-mob {
    padding: ${toRem(32)} 0;
  }
  
  .row {
    margin: 0;
  }
  .wysiwyg-first-letter {
    p:first-of-type {
      &::first-letter {
        font-family: var(--t-font-family, 'GTSuperDisplay');
        font-size: 55px;
        font-style: normal;
        font-weight: 300;
        line-height: 110%; /* 60.5px */
        text-transform: uppercase;
        padding-right: ${toRem(4)};
        color: var(--t-accent-color); !important;
        initial-letter: 2;
        -webkit-initial-letter: 2;
        @-moz-document url-prefix() {
          float: left;
          padding: ${toRem(3)};
        }
          [dir='rtl'] & {
          padding-left: ${toRem(4)};
          padding-right: 0;
        }
      }
    }
  }
  .mob-view-gutter-space p {
    margin-left: ${toRem(-15)};
    margin-right: ${toRem(-15)};
    @media ${baseVariables.mediaQuery.md} {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;
